import React from 'react'
import { useTranslation } from 'next-i18next'
import { Typography } from 'antd'
import { CustomModal } from 'src/components'
const { Title } = Typography


const ProjectFormRegistryValidationErrorModal = ({ isModalVisible, handleCancel, registryName }) => {

  const { t } = useTranslation()
  let messageHTML = null
  if (registryName) {
    const messages = t('MyProjects.RegistryValidationError.Message', { returnObjects: true })
    const entry = Object.entries(messages).find(([key]) => registryName.includes(key))
    messageHTML= entry ? entry[1] : ''

  }

  return (
    <>
      <CustomModal
        title={t('MyProjects.RegistryValidationError.Title')}
        footer={null}
        open={isModalVisible}
        onCancel={handleCancel}
      >
        {messageHTML && (
          <Title level={5} type='secondary'>
            <div dangerouslySetInnerHTML={{ __html: messageHTML }} />
          </Title>
        )}
      </CustomModal>
    </>
  )
}
export default ProjectFormRegistryValidationErrorModal
